import { render, staticRenderFns } from "./SorryPopup.vue?vue&type=template&id=66173b51&scoped=true"
import script from "./SorryPopup.vue?vue&type=script&lang=js"
export * from "./SorryPopup.vue?vue&type=script&lang=js"
import style0 from "./SorryPopup.vue?vue&type=style&index=0&id=66173b51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66173b51",
  null
  
)

export default component.exports